try{
 
var productPriceDisplay  = document.querySelector(".product-single__price");
var percentAmountDisplay = document.querySelector(".percent");  
var __currentUrl = document.URL;
 
/* START AUTOMATICLY APPLY DISCOUNT VIA QUERY STRING */
var urlParams = new URLSearchParams(window.location.search);
var discountCode = urlParams.get('discount');


/*END Currently Product Viewing*/
if (typeof __SetPageURLCookie != "undefined") {
 
    __setCookie('currenturlcookie', __currentUrl);
}
if (typeof __currentProduct != "undefined") {
    __setCookie('funnel_current_variant_id', __currentProduct);
}
  
  function formatMoney($amount){
    var i = parseInt($amount),  res = (i / 100).toFixed(2);
    return res;
  }
  
  function onVisible(element, callback) {
    new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if(entry.intersectionRatio > 0) {
          callback(element);
          observer.disconnect();
        }
      });
    }).observe(element);
    if(!callback) return new Promise(r => callback=r);
  }
 
  function url_redirect(url){
    var X = setTimeout(function(){
        window.location.replace(url);
        return true;
    },300);

    if( window.location = url ){
        clearTimeout(X);
        return true;
    } else {
        if( window.location.href = url ){
            clearTimeout(X);
            return true;
        }else{
            clearTimeout(X);
            window.location.replace(url);
            return true;
        }
    }
    return false;
};
 
window.onload = function() {
    if (window.jQuery) {
      
  
        if (!__getCookie('geocountrydata')) {
            $.get("https://ipinfo.io/json", function(response) {

                __setCookie('geocountrydata', JSON.stringify(response), 90);
            }, "jsonp");
        }
        var geoip = __getCookie('geocountrydata');
 
        /*Start  Currently Product Viewing*/
        $.fn.isInViewport = function() {
            var elementTop = $(this).offset().top;
            var elementBottom = elementTop + $(this).outerHeight();
            var viewportTop = $(window).scrollTop();
            var viewportBottom = viewportTop + $(window).height();
            return elementBottom > viewportTop && elementTop < viewportBottom;
        };

        function _scrollTo(selector, yOffset = 0) {
            var el = document.querySelector(selector);
            var y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;

            window.scrollTo({
                top: y,
                behavior: 'smooth'
            });
        }

        function __positionFixedElement() {
            if ($('.announcement-bar-carousel').length > 0) {
                if ($('.announcement-bar-carousel').isInViewport() == false) {
                    if ($(window).width() > 767) {
                        $("#chat-button").attr("style", "top:65px !important; right:1%; visibility: visible; width: 70px; height: 70px;  ");


                    } else {
                        $("#smile-ui-lite-launcher-frame-container").attr("style", "top:130px !important; display: block; width: 50px; right: 10px; position: fixed; z-index: 0;");
                        $("#chat-button").attr("style", "top:65px !important; right:-5px; visibility: visible; width: 70px; height: 70px;   ");
                    }

                } else {
                    if ($(window).width() > 767) {
                        $("#chat-button").attr("style", "top:115px !important; right:1%; visibility: visible; width: 70px; height: 70px;  ");
                    } else {
                        $("#smile-ui-lite-launcher-frame-container").attr("style", "top:180px !important; display: block; width: 50px; right: 10px; position: fixed; z-index: 0;");

                        $("#chat-button").attr("style", "top:113px !important; right:-5px; visibility: visible; width: 70px; height: 70px;  ");
                    }
                }
            }

            $("#smile-ui-lite-container").attr("style", "position: fixed; z-index: 147 !important;;");
        }

        $(window).scroll(function() {
            __positionFixedElement();
        })
        setTimeout(__positionFixedElement, 1000);

        function addItemToCart(variant_id, qty, frequency, unit_type) {
            // data = {
            //   "id": variant_id,
            //   "quantity": qty,
            //   "properties": {
            //     "shipping_interval_frequency": frequency,
            //     "shipping_interval_unit_type": unit_type
            //   }
            // }

            data = {
                "id": variant_id,
                "quantity": qty
            }
            jQuery.ajax({
                type: 'POST',
                url: '/cart/add.js',
                data: data,
                dataType: 'json',
                success: function() {
                    // window.location.href = '/cart'; 
                    window.location = '/checkout';
                }
            });
            window.location = '/checkout';
        }

      

        //DELIVERY ESTIMATOR COUNT DOWN 

        

        
    }
};

    function clearcart(){
    $.ajax({
      type: "POST",
      url: '/cart/clear.js',
      data: '',
      dataType: 'json',
      success: function() {
   
        // Shopify.clear();
      },
      error: function(XMLHttpRequest, textStatus) {
        /* error code */
      }
    });
  }

  function addItemToCart(variant_id, qty, frequency, unit_type) {
  
      data = {
          "id": variant_id,
          "quantity": qty
      }
      jQuery.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: data,
          dataType: 'json',
          success: function() {
              // window.location.href = '/cart'; 
              window.location = '/checkout';
          }
      });
      window.location = '/checkout';
  }
 
 

  function renderProductPricing(e) {
      var _product = e.detail;
      if (_product == null) return false;
      var _productPrice = formatMoney(_product.price);
      var _productCompareAtPrice, _percentSavings;
      productPriceDisplay.setAttribute('content', _product);
      productPriceDisplay.innerHTML = '$' + (_productPrice).toLocaleString('en-US', {
          style: 'currency',
          currency: 'USD'
      });
  
      if (typeof _product.compareAtPrice !== "undefined") {
          _productCompareAtPrice = formatMoney(_product.compareAtPrice);
          /*MATH*/
          var decrese = _productCompareAtPrice - _productPrice;
          _percentSavings = (decrese / _productCompareAtPrice) * 100;
          percentAmountDisplay.innerHTML = '-' + Math.round(_percentSavings) + '% OFF';
      }
  }

  function renderProductSubscribtionOptions(e) {
      var savingsBadgeDisplay = document.querySelector(".sls-savings-badge");
      savingsBadgeDisplay.innerHTML = 'EXTRA 20% OFF';
  
      /*SEAL SUBSCRIBTION DETTECT "common" */
      var sealSubscribtionSelect = document.querySelector(".sls-select");
      var sealSubscribtionSelectOptions = document.querySelectorAll(".sls-select option");
  
      /*Find /Common/ selected text*/
      if (typeof sealSubscribtionSelect !== "undefined" && typeof sealSubscribtionSelectOptions !== "undefined") {
          var selectorMatch = /\bCommon\b/;
          var selectionText, selectionValue;
  
          for (i = 0; i < sealSubscribtionSelectOptions.length; i++) {
              selectionText = sealSubscribtionSelectOptions[i].text;
              selectionValue = sealSubscribtionSelectOptions[i].value;
              if (selectionText.match(selectorMatch)) {
                  sealSubscribtionSelectOptions[i].selected = true;
              }
          }
      }
  
  }
 
  
  /* SEAL SUBSCRIBTION DETTECT EVENTS */
  document.addEventListener('sealsubs:subscription_widget_created', function(e) {
  
      /*
    renderProductPricing(e);
      renderProductSubscribtionOptions(e);
  
    setTimeout(function() {
     renderProductSubscribtionOptions(e);
    }, 2000);
   */
  
  });

  document.addEventListener('sealsubs:price_update', function(e) {
      renderProductPricing(e);
      var savingsBadgeDisplay = document.querySelector(".sls-savings-badge");
      savingsBadgeDisplay.innerHTML = 'EXTRA 20% OFF';
  });


  if (typeof meta.product !== "undefined" && typeof meta.product.id !== "undefined") {
    var socialShareButtons = document.querySelectorAll(".social-sharing__link");

    /*Social share Counter*/
    var socailShareCounter = {
        "7680292094110":{
            "facebook": "3.1K",
            "twitter": "2.2K",
            "pinterest": "2.1K",
        },
        "7558889767070": {
            "facebook": "13.2K",
            "twitter": "4.3K",
            "pinterest": "2.1K",
        },
        "7563907727518": {
            "facebook": "10.1K",
            "twitter": "3.9K",
            "pinterest": "1.8K",
        }
    };

    if (typeof socialShareButtons !== "undefined" && socialShareButtons.length > 0 && typeof socailShareCounter === "object") {
        // console.log(socailShareCounter[meta.product.id]);
        if(document.querySelector(".social-sharing__link.share-facebook > span.share-title")){
          var facebook_share_icon = document.querySelector(".social-sharing__link.share-facebook > span.share-title");
          var facebook_share_count = socailShareCounter[meta.product.id].facebook;
          facebook_share_icon.innerHTML = facebook_share_icon.innerHTML + ' <b>' + facebook_share_count + '</b>';
        }
    
        if(document.querySelector(".social-sharing__link.share-twitter > span.share-title")){
           var twitter_share_icon = document.querySelector(".social-sharing__link.share-twitter > span.share-title");
           var twitter_share_count = socailShareCounter[meta.product.id].twitter;
           twitter_share_icon.innerHTML = twitter_share_icon.innerHTML + ' <b>' + twitter_share_count + '</b>';
        }
 
        if( document.querySelector(".social-sharing__link.share-pinterest > span.share-title")){
          var pinterest_share_icon = document.querySelector(".social-sharing__link.share-pinterest > span.share-title");
          var pinterest_share_count = socailShareCounter[meta.product.id].pinterest;
          pinterest_share_icon.innerHTML = pinterest_share_icon.innerHTML + ' <b>' + pinterest_share_count + '</b>';
        }
 

    }
 
  } 
 
   $(document).ready(function() { //DELIVERY START  ESTIMATOR COUNT DOWN
 
       
         if(urlParams.get('clearcart')){
            clearcart();
          }

            function calculateHMSleft() {
                var showing = false;
                var d = new Date();
                var weekday = new Array(7);
                weekday[0] = "Sun,";
                weekday[1] = "Mon,";
                weekday[2] = "Tue,";
                weekday[3] = "Wed,";
                weekday[4] = "Thu,";
                weekday[5] = "Fri,";
                weekday[6] = "Sat,";
                var monthday = new Array(12);
                monthday[0] = "Jan";
                monthday[1] = "Feb";
                monthday[2] = "Mar";
                monthday[3] = "Apr";
                monthday[4] = "May";
                monthday[5] = "Jun";
                monthday[6] = "Jul";
                monthday[7] = "Aug";
                monthday[8] = "Sep";
                monthday[9] = "Oct";
                monthday[10] = "No";
                monthday[11] = "Dec";
                //calculate

                var now = new Date(___current_date);
                var hoursleft = now.getHours();
                if (now.getHours() <= 17) {
                    hoursleft = 17 - now.getHours();
                } else {
                    hoursleft = 24 - hoursleft + 17;
                }

                var minutesleft = 59 - now.getMinutes();
                var secondsleft = 59 - now.getSeconds();

                //format 0 prefixes
                if (minutesleft < 10) minutesleft = "0" + minutesleft;
                if (secondsleft < 10) secondsleft = "0" + secondsleft;

                //display
                $('.HMSremaining').html(hoursleft + " hrs " + minutesleft + " mins.");

                if (document.getElementById("delivery-date-latest") == null) return false;
                if (hoursleft > 12) {
                    if (d.getDay() == 0 || d.getDay() <= 2) {
                        d.setHours(d.getHours() + 72);
                        var deliver = weekday[d.getDay()];
                        var day = d.getDate();
                        var month = monthday[d.getMonth()];
                        document.getElementById("delivery-date-latest").innerHTML = deliver + ' ' + month + ' ' + day;
                    } else if (d.getDay() == 3) {
                        d.setHours(d.getHours() + 72);
                        var deliver = weekday[d.getDay()];
                        var day = d.getDate();
                        var month = monthday[d.getMonth()];
                        document.getElementById("delivery-date-latest").innerHTML = deliver + ' ' + month + ' ' + day;
                    } else {
                        d.setHours(d.getHours() + 96);
                        var deliver = weekday[d.getDay()];
                        var day = d.getDate();
                        var month = monthday[d.getMonth()];
                        document.getElementById("delivery-date-latest").innerHTML = deliver + ' ' + month + '-' + day;
                    }
                } else {
                    if (d.getDay() > 0 || d.getDay() <= 3) {
                        d.setHours(d.getHours() + 48);
                        var deliver = weekday[d.getDay()];
                        var day = d.getDate();
                        var month = monthday[d.getMonth()];
                        document.getElementById("delivery-date-latest").innerHTML = deliver + ' ' + month + ' ' + day;
                    } else if (d.getDay() == 0) {
                        d.setHours(d.getHours() + 48);
                        var deliver = weekday[d.getDay()];
                        var day = d.getDate();
                        var month = monthday[d.getMonth()];
                        document.getElementById("delivery-date-latest").innerHTML = deliver + ' ' + month + ' ' + day;
                    } else {
                        d.setHours(d.getHours() + 96);
                        var deliver = weekday[d.getDay()];
                        var day = d.getDate();
                        var month = monthday[d.getMonth()];
                        document.getElementById("delivery-date-latest").innerHTML = deliver + ' ' + month + '-' + day;
                    }
                }

                try {
                    geoip = JSON.parse(geoip);

                    if (geoip.country !== null && geoip.country != "US") {
                        var country = geoip.country;
                        var region = 'all regions';

                        $('.delivery-date-esitmator').html(`We produly ship to <img src="https://cderma.com/cdn/shop/t/9/assets/` + country + `.svg" width="24" height"24">, ` + region);
                    }
                } catch (e) {
                    $('.delivery-date-esitmator').fadeIn(100);
                    return false;
                }

                if (showing == false) {
                    $('.delivery-date-esitmator').fadeIn(100);
                    showing = true;
                }

                $('.delivery-date-esitmator').fadeIn(100);

            }

            calculateHMSleft();
            setInterval(calculateHMSleft, 60000);
              
        }); //DELIVERY END  ESTIMATOR COUNT DOWN 


  

 }catch (e){
       console.error('Something is wrong with custom.js');
       console.error(e);
      
}